import { Controller } from "@hotwired/stimulus"
import autoComplete from "@tarekraafat/autocomplete.js"
import { get } from "@rails/request.js"

export default class extends Controller {
  static targets = ['autocompleteField']
  static values = { type: Array, recordId: Number }

  connect() {
    new autoComplete({
      debounce: 300,
      searchEngine: "loose",
      selector: `#${this.autocompleteFieldTarget.id}`,
      threshold: 2,

      data: {
        src: async () => {
          const response = await get(`/subjects/search/new?term=${encodeURI(this.autocompleteFieldTarget.value)}&type=${this.typeValue}`, { responseKind: "json" });
          if (response.ok) {
            const data = await response.json;
            return data;
          };
        },
        keys: ["name", "description"],
        cache: false
      },
           
      resultsList: {
        maxResults: 10,
      },

      resultItem: {
        element: (item, data) => {
          item.innerHTML = `${data.value.type} - <span class="font-semibold">${data.value.name}</span> ${data.value?.description}`;
        }
      },

      events: {
        input: {
          selection: (event) => {
            this.element.parentElement.setAttribute("src", `/referral/records/${this.recordIdValue}/fieldsets/${event.detail.selection.value.gid}`)
          }
        }
      }
    });
  }
}